import { useMemo } from "react";
import { useTranslations } from "use-intl";
import ReferencePicker from "./reference-picker";
import type {
  WorkflowReferenceAction,
  WorkflowReferenceItem,
} from "@/types/workflow-reference.types";

type MediaKind = "image" | "video" | "audio" | "raw_doc";

export interface MediaAssetPickerProps {
  value: string[];
  onChange: (ids: string[]) => void;
  kinds?: MediaKind[];
  disabled?: boolean;
  placeholder?: string;
  action?: WorkflowReferenceAction;
  nodeType?: string;
  fieldKey?: string;
}

export function MediaAssetPicker({
  value,
  onChange,
  kinds = ["image", "video", "audio", "raw_doc"],
  disabled,
  placeholder,
  action = "read",
  nodeType,
  fieldKey = "media_asset_ids",
}: MediaAssetPickerProps) {
  const t = useTranslations("workflows");
  const allowedKinds = useMemo(() => new Set(kinds), [kinds]);
  const optionFilter = (item: WorkflowReferenceItem) => {
    const kind = item.subtitle as MediaKind | undefined;
    return !kind || allowedKinds.has(kind);
  };

  return (
    <ReferencePicker
      kind="media_asset"
      action={action}
      nodeType={nodeType}
      fieldKey={fieldKey}
      value={value}
      onChange={onChange}
      disabled={disabled}
      placeholder={placeholder ?? t("drawer.reference.search_media")}
      optionFilter={optionFilter}
    />
  );
}

export default MediaAssetPicker;
